import React from "react";
import CreatableSelect from "react-select";
const AutoCompleteField = ({
  onInputChange,
  formatOptionLabel,
  options,
  placeholder,
  style,
  defaultValue,
  onChange,
  ...rest
}) => {
  const selectControlStyles = {
    ...style,
    transition:
      "color 0.15s ease, background-color 0.15s ease, border-color 0.15s ease, box-shadow 0.15s ease",
  };

  const colourStyles = {
    control: (styles) => ({
      alignItems: "center",
      backgroundColor: "hsl(0, 0%, 100%)",
      display: "flex",
      flexWrap: "wrap",
      justifyContent: "space-between",
      label: "control",
      minHeight: 50,
      outline: "0 !important",
      position: "relative",
      transition: "all 100ms",
      "&:hover": {
        cursor: "pointer",
        backgroundColor: "#d9e4f6",
      },
      ...selectControlStyles,
    }),
    option: (styles) => {
      return {
        "&:hover": {
          cursor: "pointer",
        },
        ...styles,
      };
    },
  };
  const theme = (theme) => {
    return {
      ...theme,
      colors: {
        ...theme.colors,
        primary25: "#F3F6F9",
        primary: "#2555ef",
      },
    };
  };
  return (
    <div>
      <CreatableSelect
        classNamePrefix="react-select"
        formatOptionLabel={formatOptionLabel}
        options={options}
        styles={colourStyles}
        placeholder={placeholder}
        onInputChange={onInputChange}
        onChange={(value) => onChange(value)}
        defaultValue={defaultValue}
        theme={theme}
        {...rest}
      />
    </div>
  );
};

export default AutoCompleteField;
